// extracted by mini-css-extract-plugin
module.exports = {"sideMenuWrapper":"styles_sideMenuWrapper__2xSeh"};